/* Doku und Begruendung: snippets/tuner-vorlage.liquid (rendert 0 Bytes, laedt diese Datei). */
(function () {
  var SEARCH = window.location.search + window.location.hash;
  var eintraege = {};   // sku -> { el, opts, lastKey, kontextBox }

  function aktiv(sku) {
    return new RegExp(sku.replace(/-/g, '\\-') + 'tuner=1').test(SEARCH);
  }

  function makeRow(item, update) {
    if (item.h) {
      var hh = document.createElement('h5');
      hh.textContent = item.h;
      hh.style.cssText = 'margin:8px 0 3px;font-size:11px;color:' + (item.farbe || '#c4a574');
      return hh;
    }
    var row = document.createElement('div');
    row.className = 'kt-row';
    row.style.cssText = 'display:flex;align-items:center;gap:6px;margin:2px 0';
    var lab = document.createElement('label');
    lab.textContent = item.label;
    lab.title = item.label;      // deutscher Schluessel bleibt im Tooltip (Uebersetzung)
    /* Farben inline festnageln: das Panel ist dunkel, aber Produkt-CSS aus
       der Handbau-Zeit (z.B. #k530-tuner label { color:#444 }) und Theme-
       Input-Regeln faerben sonst grau-auf-dunkel bzw. grau-auf-weiss
       (Yin, 2026-08-19: Beschriftung weiss, Zahlen im weissen Feld schwarz). */
    lab.style.cssText = 'flex:1;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#fff';
    var inp = document.createElement('input');
    inp.type = 'number';
    inp.step = item.step || 0.5;
    var v = item.get();
    inp.value = (v == null ? '' : v);
    inp.style.cssText = 'width:74px;font:11px monospace;color:#000;background:#fff;border:1px solid #888';
    // eigener Listener je Feld — Tippen behaelt den Fokus
    inp.addEventListener('input', function () {
      var n = parseFloat(inp.value);
      if (!isNaN(n)) { item.set(n); update(); }
    });
    row.appendChild(lab);
    row.appendChild(inp);
    return row;
  }

  function fuelle(box, items, update) {
    box.innerHTML = '';
    for (var i = 0; i < items.length; i++) box.appendChild(makeRow(items[i], update));
  }

  function baue(sku, opts) {
    var el = document.createElement('div');
    el.id = sku + '-tuner';
    el.style.cssText = 'position:fixed;left:10px;bottom:10px;z-index:999999;width:300px;' +
      'max-height:80vh;overflow-y:auto;background:#1f1f1f;color:#eee;padding:8px 10px;' +
      'border-radius:6px;box-shadow:0 8px 28px rgba(0,0,0,.4);font:12px/1.4 Menlo,Consolas,monospace';

    var kopf = document.createElement('div');
    kopf.className = 'kt-title';
    kopf.style.cssText = 'font-weight:700;font-size:12px;margin-bottom:6px';
    kopf.textContent = opts.titel || (sku.toUpperCase() + ' Tuner');
    el.appendChild(kopf);

    var statisch = document.createElement('div');
    el.appendChild(statisch);
    fuelle(statisch, (typeof opts.statisch === 'function' ? opts.statisch() : opts.statisch) || [], opts.update);

    var kontextBox = null;
    if (opts.kontext) {
      var kh = document.createElement('h5');
      kh.textContent = '▼ Kontext (folgt der Auswahl im Fenster)';
      kh.style.cssText = 'margin:10px 0 3px;font-size:11px;color:#c4a574';
      el.appendChild(kh);
      kontextBox = document.createElement('div');
      /* Der Kontextteil braucht eine Adresse: die Pruefskripte der
         handgebauten Panels sprachen ihn als #<sku>-tuner-kontext an,
         und nach der Umstellung stand er ohne id da — jede solche
         Zusicherung wurde still rot. */
      kontextBox.id = sku + '-tuner-kontext';
      el.appendChild(kontextBox);
      fuelle(kontextBox, opts.kontext() || [], opts.update);
    }

    var foot = document.createElement('div');
    foot.style.cssText = 'border-top:1px solid #444;margin-top:8px;padding-top:6px';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-kt-copy', '');
    btn.textContent = 'Alle Werte anzeigen & kopieren';
    var ta = document.createElement('textarea');
    ta.readOnly = true;
    ta.setAttribute('data-kt-copy-out', '');
    ta.style.cssText = 'display:none;width:100%;height:150px;font:10px monospace;margin-top:4px;color:#000;background:#fff';
    btn.addEventListener('click', function () {
      ta.style.display = 'block';
      ta.value = JSON.stringify(opts.exportiere ? opts.exportiere() : {}, null, 1);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
    });
    foot.appendChild(btn);
    foot.appendChild(ta);
    el.appendChild(foot);

    document.body.appendChild(el);
    /* Einbauplatz fuer produktspezifische Bedienelemente, die KEINE
       Zahlenregler sind (K530: Bestellung-einlesen-Box, Familie->PNG-Export).
       Das Produkt bekommt das fertige Panel und haengt seine Abschnitte
       selbst ein (insertBefore fuer oben). Fehler darin duerfen das Panel
       nicht mitreissen. */
    if (opts.einbau) {
      try { opts.einbau(el); } catch (e) {
        try { console.warn('VivTuner einbau(' + sku + '):', e); } catch (e2) {}
      }
    }
    return { el: el, opts: opts, kontextBox: kontextBox, lastKey: null };
  }

  /* ======================================================================
     VOLLAUSBAU — Reglerfamilien aus dem Steckbrief statt aus der Abschrift.

     Warum: Die Huelle (register) beendete das Panel-Handwerk, aber WELCHE
     Regler existieren, schrieb weiter jedes Produkt selbst — und Abschriften
     vererben Luecken (tuner_audit: 24 von 83 Tunern vollstaendig, identisch
     ausgestattete Produkte mit 22 bis 66 Reglern). vollausbau() dreht das um:
     das Produkt liefert einen STECKBRIEF (Schriften, Motive, Layouts) und je
     Familie einen ZUGRIFF auf seine Konfigtabellen; die Familienliste selbst
     — was es geben MUSS — steht hier, einmal, deckungsgleich mit
     scripts/tuner_audit.py. Fehlt ein geforderter Zugriff, erscheint im
     Panel eine rote FEHLT-Zeile: Luecken sind sichtbar, nicht still.

     Steckbrief m:
       titel        wie register()
       schriften    ['G02', …]           — Traeger fuer D2/D3-Pflicht
       motive       ['W01', …]           — Traeger fuer G1/G2/D1/D3-Pflicht
       layouts      { kombi: ['text_plus_motiv', …] }  — Traeger fuer K1/K2
       auswahl()    aktueller Kontext aus dem FENSTER (Objekt; wird
                    JSON-stringifiziert als kontextKey benutzt und den
                    Kontext-Zugriffen unveraendert uebergeben; ein Feld
                    `titel` wird als Kopfzeile gezeigt)
       zugriff      { G1: fn(ctx), G2: fn(ctx), … }  — je Familie eine
                    Funktion, die fuer den Kontext ihre Zeilen liefert:
                    [{ achse:'x'|'y', suffix:'14mm', step, get, set }, …]
                    [] heisst „in DIESEM Kontext nichts zu tun" (kein Mangel);
                    ein STRING heisst „gibt es bei diesem Produkt gar nicht,
                    und zwar aus diesem Grund" — die Vorlage zeigt ihn als
                    graue Zeile. Damit steht die Entscheidung IM FENSTER statt
                    im Kopf des Entwicklers (mk003: Text und Motiv kommen nie
                    zusammen vor, ein Abstand zwischen ihnen existiert nicht).
                    Fehlt der Eintrag ganz, ist das ein Mangel -> rote Zeile.
                    Beschriftungen baut die Vorlage KANONISCH (tuner_audit).
       statischExtra() / kontextExtra(ctx)   zusaetzliche Produkt-Zeilen
       einbau(el)   DOM-Haken fuer Nicht-Zahlen-Bedienelemente
       update / exportiere   wie register()

     Stub fuer Produkt-Snippets, die VOR der Vorlage laden. WICHTIG: ein
     fremder ALT-Stub (anderes Produkt lud zuerst, ohne vollausbau) muss
     ergaenzt werden, sonst wirft der Aufruf — deshalb zwei Schritte:

       window.VivTuner = window.VivTuner || { q: [], refresh: function () {},
         register: function () { this.q.push(arguments); return { refresh: function () {} }; } };
       if (!window.VivTuner.vollausbau) window.VivTuner.vollausbau =
         function () { this.q.push({ va: arguments }); return { refresh: function () {} }; };
       window.VivTuner.vollausbau('a999', { … });
     ====================================================================== */
  var FAMILIEN = [
    /* statisch=true -> Gesamtteil (ctx null), sonst Kontextteil.
       vorn=true -> suffix VOR die Beschriftung (Audit-Muster „…$"). */
    { id: 'G3', basis: 'Gesamt: Block',          achsen: true,  statisch: true,  braucht: 'immer' },
    { id: 'G4', basis: 'Gesamt: Block-Größe ×',  achsen: false, statisch: true,  braucht: 'immer' },
    { id: 'G1', basis: 'Gesamt: Motive',         achsen: true,  statisch: true,  braucht: 'motive' },
    { id: 'G2', basis: 'Gesamt: Motiv-Größe ×',  achsen: false, statisch: true,  braucht: 'motive' },
    { id: 'K1', basis: 'Kombi: Text',            achsen: true,  statisch: false, braucht: 'kombi' },
    { id: 'K2', basis: 'Kombi: Motiv',           achsen: true,  statisch: false, braucht: 'kombi' },
    { id: 'D2', basis: 'Text-Größe (Font)',      achsen: false, statisch: false, braucht: 'schriften' },
    { id: 'D1', basis: 'Motiv-Größe',            achsen: false, statisch: false, braucht: 'motive', vorn: true },
    { id: 'D3', basis: 'Abstand (Font×Motiv)',   achsen: false, statisch: false, braucht: 'motive_und_schriften' },
    /* Die zwei Begrenzer sind neu (2026-08-19, Wunsch der Haendlerin):
       je Kontext eine harte Breiten-/Hoehenkappe, ueber der verkleinert wird.
       Pflicht nur fuer Vollausbau-Produkte — tuner_audit zaehlt sie dort mit. */
    { id: 'LB', basis: 'Limit: Breite max %',    achsen: false, statisch: false, braucht: 'immer' },
    { id: 'LH', basis: 'Limit: Höhe max %',      achsen: false, statisch: false, braucht: 'immer' }
  ];

  function famGefordert(fam, m) {
    var mo = (m.motive || []).length > 0;
    var sc = (m.schriften || []).length > 1;
    var ko = ((m.layouts || {}).kombi || []).length > 0;
    if (fam.braucht === 'immer') return true;
    if (fam.braucht === 'motive') return mo;
    if (fam.braucht === 'schriften') return sc;
    if (fam.braucht === 'motive_und_schriften') return mo && sc;
    if (fam.braucht === 'kombi') return ko;
    return true;
  }

  function famLabel(fam, zeile) {
    var b = fam.basis;
    if (fam.achsen) b += (zeile.achse === 'y' ? ' ↕ Y %' : ' ↔ X %');
    if (zeile.suffix) return fam.vorn ? (zeile.suffix + ' · ' + b) : (b + ' · ' + zeile.suffix);
    return b;
  }

  function famZeilen(fam, m, ctx) {
    if (!famGefordert(fam, m)) return [];
    var zug = (m.zugriff || {})[fam.id];
    if (!zug) {
      return [{ h: '✗ FEHLT ' + fam.id + ' — ' + fam.basis, farbe: '#e0402f' }];
    }
    var zeilen, aus = [], i, z;
    try { zeilen = zug(ctx) || []; } catch (e) {
      return [{ h: '✗ ' + fam.id + ' Zugriff wirft: ' + e, farbe: '#e0402f' }];
    }
    // String = begruendetes „gibt es hier nicht" -> grau, nicht rot, nicht still
    if (typeof zeilen === 'string') {
      return [{ h: '— ' + fam.id + ' ' + fam.basis + ': ' + zeilen, farbe: '#8a8a8a' }];
    }
    for (i = 0; i < zeilen.length; i++) {
      z = zeilen[i];
      aus.push({ label: famLabel(fam, z), step: z.step, get: z.get, set: z.set });
    }
    return aus;
  }

  var VivTuner = {
    vollausbau: function (sku, m) {
      var soll = 0, hat = 0, i;
      for (i = 0; i < FAMILIEN.length; i++) {
        if (!famGefordert(FAMILIEN[i], m)) continue;
        soll++;
        if ((m.zugriff || {})[FAMILIEN[i].id]) hat++;
      }
      var abzeichen = hat + '/' + soll + ' Familien' + (hat < soll ? ' ⚠' : '');
      function statisch() {
        var it = [{ h: 'Gesamt' }], i2;
        for (i2 = 0; i2 < FAMILIEN.length; i2++) {
          if (FAMILIEN[i2].statisch) it = it.concat(famZeilen(FAMILIEN[i2], m, null));
        }
        if (m.statischExtra) it = it.concat(m.statischExtra() || []);
        return it;
      }
      function kontext() {
        var ctx = m.auswahl ? m.auswahl() : {};
        var it = [], i2;
        if (ctx && ctx.titel) it.push({ h: ctx.titel });
        for (i2 = 0; i2 < FAMILIEN.length; i2++) {
          if (!FAMILIEN[i2].statisch) it = it.concat(famZeilen(FAMILIEN[i2], m, ctx));
        }
        if (m.kontextExtra) it = it.concat(m.kontextExtra(ctx) || []);
        return it;
      }
      function kontextKey() {
        var ctx = m.auswahl ? m.auswahl() : {};
        try { return JSON.stringify(ctx); } catch (e) { return String(ctx); }
      }
      return this.register(sku, {
        titel: (m.titel || (sku.toUpperCase() + ' Tuner')) + ' · ' + abzeichen,
        statisch: statisch,
        kontext: kontext,
        kontextKey: kontextKey,
        einbau: m.einbau,
        update: m.update,
        exportiere: m.exportiere
      });
    },

    register: function (sku, opts) {
      if (!aktiv(sku) || eintraege[sku]) {
        return { refresh: function () {} };
      }
      function anlegen() {
        if (!document.body) { return; }
        if (!eintraege[sku]) eintraege[sku] = baue(sku, opts);
      }
      if (document.body) anlegen();
      else document.addEventListener('DOMContentLoaded', anlegen);
      var griff = { refresh: function () { VivTuner.refresh(sku); } };
      return griff;
    },

    /* Kontext an die Auswahl anpassen. Bewusst billig: neu gebaut wird nur,
       wenn sich kontextKey aendert — deshalb darf (und soll!) updatePreview
       diesen Aufruf bei jedem Lauf machen. Der A184-Fehler (definierter,
       nie gerufener Refresh) ist mit dieser Vorlage strukturell erledigt,
       solange die eine Zeile in updatePreview steht; das prueft
       tuner_audit.py ueber den VivTuner.refresh-Aufruf im Quelltext. */
    refresh: function (sku) {
      var e = eintraege[sku];
      if (!e || !e.kontextBox || !e.opts.kontext) return;
      // Ohne kontextKey wird NICHT neu gebaut: ein Neuaufbau bei jedem
      // Aufruf wuerfe mitten im Tippen den Fokus weg. Wer einen folgenden
      // Kontext will, liefert den Key — der sagt, WANN sich etwas geaendert hat.
      var key = e.opts.kontextKey ? e.opts.kontextKey() : '(fest)';
      if (key === e.lastKey) return;
      e.lastKey = key;
      fuelle(e.kontextBox, e.opts.kontext() || [], e.opts.update);
    }
  };

  // Stub-Queue abarbeiten: Registrierungen, die vor dieser Datei ankamen
  var vorher = window.VivTuner;
  window.VivTuner = VivTuner;
  if (vorher && vorher.q && vorher.q.length) {
    for (var i = 0; i < vorher.q.length; i++) {
      /* Zwei Stub-Formen: register pusht seine arguments direkt,
         vollausbau pusht { va: arguments } — sonst waeren sie im
         Abarbeiten nicht zu unterscheiden. */
      if (vorher.q[i] && vorher.q[i].va) {
        VivTuner.vollausbau.apply(VivTuner, vorher.q[i].va);
      } else {
        VivTuner.register.apply(VivTuner, vorher.q[i]);
      }
    }
  }
})();
